import type { PageBadge } from '@components/SitemapReport/types'
import { Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { getBadgeHint } from './utils'

const DisabledLinkBadgeKinds = new Set<PageBadge['kind']>([
  'skipped',
  'removed',
])

interface Props {
  url: string
  status: number | null
  title: string | null
  h1: string | null
  // When a crawl last saw this page change, already formatted. It outlives the
  // `updated` badge, which is about the latest crawl only.
  changedAt: string | null
  badges: PageBadge[]
}

export const PageRow: React.FC<Props> = ({
  url,
  badges,
  title,
  h1,
  changedAt,
  status,
}) => {
  const disabled = badges.some(({ kind }) => DisabledLinkBadgeKinds.has(kind))

  return (
    <>
      <div className={css.page_row}>
        <a
          href={url}
          className={clsJoin(css.link, disabled && css.disabled)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
        <div className={css.badges}>
          {badges.map(({ kind, type, title }) => {
            const hint = getBadgeHint(kind, status)

            return (
              <Tooltip key={title} label={hint} multiline>
                <button
                  type="button"
                  className={clsJoin(css.badge, css[type], css.explained)}
                >
                  {title}
                </button>
              </Tooltip>
            )
          })}
        </div>
      </div>
      {(title || h1 || changedAt) && (
        <div className={css.metadata}>
          {title && (
            <div className={css.metadata_row}>
              <span className={css.metadata_label}>T</span>
              <span>{title}</span>
            </div>
          )}
          {h1 && (
            <div className={css.metadata_row}>
              <span className={css.metadata_label}>H1</span>
              <span>{h1}</span>
            </div>
          )}
          {changedAt && <div>Updated {changedAt}</div>}
        </div>
      )}
      <div className={css.page_row_divider} />
    </>
  )
}
